<div class="{{ this.isDesktop ? 'view-desktop' : 'view-mobile' }}">
    <div class="questions-group" *ngFor="let key of objectKeys(formQuestionsGrouped)" [ngStyle]="{'border-color': formQuestionsGrouped[key][0].get('question').value.category.color}">
        <div class="question-group-category" [ngStyle]="{'background': formQuestionsGrouped[key][0].get('question').value.category.color}">{{ formQuestionsGrouped[key][0].get('question').value.category.name | translate }}</div>
        <div *ngFor="let control of formQuestionsGrouped[key]" [formGroup]="control">

            <evaluation-athlete-question
                    [value]="control.get('answer').value"
                    [question]="control.get('question').value"
                    [evaluationAthlete]="evaluationAthlete"
                    (questionEvent)="questionEvent($event)"
                    [isDesktop]="this.isDesktop"></evaluation-athlete-question>

            <div [hidden]="true">
                <mat-form-field class="no-mat-form-field-underline">
                    <input matInput formControlName="id" [value]="control.get('id').value" type="number" autocomplete="off">
                </mat-form-field>

                <mat-form-field class="no-mat-form-field-underline">
                    <input matInput formControlName="answer" type="number" autocomplete="off">
                </mat-form-field>
            </div>
        </div>
    </div>
</div>
